import cn from "classnames";
import Styles from "./PitchSmart.module.scss";
import { PITCH_SMART_BRACKETS, MAX_REST_DAYS, rangeLabelForRest } from "src/utils/pitch-smart";

interface PitchSmartGuidelinesProps {
  /** id of the bracket to highlight, e.g. "13-14" */
  selectedBracketId?: string;
}

/**
 * Official MLB Pitch Smart pitch-count & required-rest table.
 * Rendered from the same data that drives the availability math
 * (src/utils/pitch-smart.ts), so the guide and the grid never drift.
 */
export default function PitchSmart({ selectedBracketId }: PitchSmartGuidelinesProps) {
  const restColumns = Array.from({ length: MAX_REST_DAYS + 1 }, (_, i) => i);

  return (
    <table className={cn(Styles.table, Styles["styled-table"], Styles.tableHover, Styles.tableBorder)}>
      <thead>
        <tr>
          <th>Age</th>
          <th>Daily Max (Pitches in Game)</th>
          {restColumns.map((r) => (
            <th key={r}>{r === 1 ? "1 Day Rest" : `${r} Days Rest`}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {PITCH_SMART_BRACKETS.map((bracket) => (
          <tr key={bracket.id} className={cn({ [Styles["active-row"]]: bracket.id === selectedBracketId })}>
            <td>{bracket.id}</td>
            <td>{bracket.dailyMax}</td>
            {restColumns.map((r) => (
              <td key={r}>{rangeLabelForRest(bracket, r)}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
